export const theme = {
  fontSize: {
    xxSmall: "10px",
    xSmall: "13px",
    small: "14px",
    normal: "16px",
    medium: "18px",
    large: "20px",
    xlarge: "22px",
    xxlarge: "36px",
    xxxLarge: "64px",
  },
  color: {
    white: "#FFFFFF",
    whisper: "#F5F5FA",
    mercury: "#E5E5E5",//background
    mystic: "#E4E6F0",//szare tło tagów
    waterloo: "#7E839A",//pasek search, szary opis w kafelkach
    stormGray: "#74788B",//szary opis w dużym kaflu
    red: "#FF6347",
    gray: "#E4E6F0",
    darkedGray: "#7E839A",
    lightBlue: "#D6E4FF",
    spindle: "#BBCCEE",
    scienceBlue: "#0044CC",//button w error
    blue: "#0044CC",
    pattensBlue: "#D6E4FF",
    black: "#000000",
  },
  media: {
    extraMobileSmall: "340px",
    extraMobile: "575.98px",
    mobile: "767.98px",
    tablet: '991.98px',
    desktop: "1199.98px",
  },
  /*   shadows: {
        lighter:"",
        light: "",
        normal: "",
        dark: "",
        darker: "",
      }, */
};

